module.exports = __webpack_public_path__ + "media/images/flags/32/Abkhazia-ed3efcd0e512f059b68398a793aa1ace.png";